import { render, staticRenderFns } from "./Advert.vue?vue&type=template&id=6c2c9986&scoped=true"
import script from "./Advert.vue?vue&type=script&lang=js"
export * from "./Advert.vue?vue&type=script&lang=js"
import style0 from "./Advert.vue?vue&type=style&index=0&id=6c2c9986&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2c9986",
  null
  
)

export default component.exports